import angular from 'angular';
import unauthorizedComponent from './unauthorized.component';

let unauthorizedModule = angular.module('unauthorized', [])

.config(($stateProvider) => {
  "ngInject";
})

.component('unauthorized', unauthorizedComponent);

export default unauthorizedModule;



// WEBPACK FOOTER //
// ./client/pages/403/unauthorized.js